import { Record } from 'immutable'

export class TrailerDocument extends Record({
    id: undefined,
    trailer_id: undefined,
    trailer: undefined,
    document_type_id: undefined,
    document_type: undefined,
    trailer_document_files_count: undefined,
    number: undefined,
    note: undefined,
    date_validity_from: undefined,
    date_validity_to: undefined,
}) {}
